import { default as WeekView } from "./week";
import { getAdder, getUnitStart, format } from "../time";
import { endOfDay } from "date-fns";
const addDays = getAdder("day");
class DayView extends WeekView {
    constructor() {
        super(...arguments);
        this.getBounds = (date) => {
            const start = getUnitStart("day", date);
            const end = endOfDay(start);
            return [start, end];
        };
        this.getNext = (date) => {
            const start = addDays(date, 1);
            return start;
        };
        this.getPrev = (date) => {
            const start = addDays(date, -1);
            return start;
        };
        this.getTitle = (date, config) => format(date, "d LLL y", { locale: config.locale });
    }
}
export default DayView;
//# sourceMappingURL=day.js.map